import { __assign, __rest } from "tslib";
import React, { useEffect, useState } from 'react';
import insertScript from './insertScript';
import { styles, merge } from './styles';
import { LIBRARY_LIST } from './constants';
var nameHash = {};
export function register(iconMap) {
    if (iconMap === void 0) { iconMap = {}; }
    Object.assign(nameHash, iconMap);
}
export function getLibraryList() {
    return Promise.resolve().then(function () { return LIBRARY_LIST; });
}
export function getLibraryInfo(libraryKey) {
    return new Promise(function (resolve, reject) {
        var library = LIBRARY_LIST.find(function (data) { return data.key === libraryKey; });
        if (library) {
            if (library.ready) {
                return resolve(library);
            }
            else {
                Promise.all([
                    // 加载 Icon types
                    fetch(library.scriptUrl + 'on'),
                    // 加载 Icon js
                    insertScript(library.scriptUrl),
                ])
                    .then(function (values) { return values[0].json(); })
                    .then(function (types) {
                    if (Array.isArray(types)) {
                        // 去除重复 icon type
                        library.types = Array.from(new Set(types));
                        library.ready = true;
                        resolve(library);
                    }
                })
                    .catch(function (e) { return console.error("Error loading " + libraryKey + " icon library js or type.", e); });
            }
        }
        else {
            reject();
        }
    }).catch(function (e) { return console.error("Failed to get " + libraryKey + " icon library.", e); });
}
export default (function (_a) {
    var type = _a.type, _b = _a.size, size = _b === void 0 ? 'default' : _b, _c = _a.className, className = _c === void 0 ? '' : _c, style = _a.style, library = _a.library, props = __rest(_a, ["type", "size", "className", "style", "library"]);
    var _d = useState(false), forceUpdate = _d[1];
    useEffect(function () {
        if (library) {
            var libraryInfo = LIBRARY_LIST.find(function (data) { return data.key === library; });
            if (libraryInfo && !libraryInfo.ready) {
                insertScript(libraryInfo.scriptUrl).then(function () {
                    forceUpdate(function (bool) { return !bool; });
                });
            }
        }
    }, [library]);
    return (React.createElement("svg", __assign({ className: className, style: merge(styles.icon, styles.size[size], type === 'icon-loading' ? styles.type.loading : {}, style), "aria-hidden": "true" }, props),
        React.createElement("use", { xlinkHref: "#" + (library ? library + "-" + type : (nameHash[type] ? nameHash[type] : type)) })));
});
